// Base paths for route matching
export const ROUTES = {
  HOME: "/",

  PRODUCTS: "/products",
  PRODUCT: "/products/:id",
  STORE: "/stores/:id",

  LOGIN: "/auth/login",
  REGISTER: "/auth/register",
  RESET_PASSWORD: "/auth/reset-password",

  CART: "/cart",
  DASHBOARD: "/dashboard",
  PURCHASES: "/user/purchases",
  PURCHASE: "/user/purchases/:id",
  DEPOSITS: "/user/deposits",
  DISPUTES: "/disputes",

  PRIVACY_POLICY: "/legal/privacy",
  TERMS_OF_USE: "/legal/terms",
  TERMS_AND_CONDITIONS: "/legal/conditions",

  STORE_DASHBOARD: "/store/dashboard",
  STORE_PRODUCTS: "/store/products",
  STORE_PRODUCT: "/store/products/:id",
  SALES: "/sales",
  WITHDRAWALS: "/store/withdrawals",
  STORE_REVIEWS: "/store/reviews",
  STORE_DISPUTES: "/store/disputes",

  TICKETS: "/tickets",
  TICKET: "/tickets/:id",

  FAQ: "/faq",
  USER_RULES: "/faq/user/rules",
  USER_HOW_TO_BUY: "/faq/user/how-to-buy",
  USER_GUARANTEES: "/faq/user/guarantees",

  STORE_BECOME_STORE: "/faq/store/become-store",
  STORE_HOW_TO_SELL: "/faq/store/how-to-sell",
  STORE_RULES: "/faq/store/rules",
  STORE_COMMISSION: "/faq/store/commission",
  STORE_GUARANTEES: "/faq/store/guarantees",
} as const;

export type PathParams = {
  [ROUTES.PRODUCT]: {
    id: string;
  };
  [ROUTES.STORE]: {
    id: string;
  };
  [ROUTES.STORE_PRODUCT]: {
    id: string;
  };
  [ROUTES.TICKET]: {
    id: string;
  };
  [ROUTES.DISPUTES]: never;
  [ROUTES.STORE_DISPUTES]: never;
  [ROUTES.SALES]: never;
};

declare module "react-router-dom" {
  interface Register {
    params: PathParams;
  }
}
